const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 60 * SECONDS_PER_MINUTE;
const SECONDS_PER_DAY = 24 * SECONDS_PER_HOUR;

const wholeUnits = (seconds, secondsPerUnit, unit) => {
  const count = Math.floor(seconds / secondsPerUnit);
  return `${count} ${count === 1 ? unit : `${unit}s`}`;
};

export const NO_VALUE = "—";

export const formatDuration = (seconds) => {
  if (seconds === null) return NO_VALUE;
  if (seconds < SECONDS_PER_MINUTE) return `${seconds} s`;
  if (seconds < SECONDS_PER_HOUR) {
    return `${Math.floor(seconds / SECONDS_PER_MINUTE)} min ${seconds % SECONDS_PER_MINUTE} s`;
  }
  if (seconds < SECONDS_PER_DAY) return wholeUnits(seconds, SECONDS_PER_HOUR, "hour");
  return wholeUnits(seconds, SECONDS_PER_DAY, "day");
};

const formatElapsed = (seconds) => {
  if (seconds < SECONDS_PER_MINUTE) return "under 1 min";
  if (seconds < SECONDS_PER_HOUR) return `${Math.floor(seconds / SECONDS_PER_MINUTE)} min`;
  return formatDuration(seconds);
};

export const formatElapsedSoFar = (seconds) => `${formatElapsed(seconds)} so far`;
